









import { UiProgressCircular } from './keen-ui';

export default {
  name: 'loading-mask',
  components: {
    UiProgressCircular
  }
};

